import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { combineReducers } from 'redux';
import {
  productCreateReviewReducer,
  productDetailsReducer,
  productListReducer,
  promoProductsReducer,
} from './Reducers/ProductReducers';
import cartReducer from './Reducers/CartReducers';
import {
  userDetailsReducer,
  userLoginReducer,
  userRegisterReducer,
  userUpdateProfileReducer,
  userGoogleLoginReducer,
} from './Reducers/userReducers';
import {
  orderCreateReducer,
  orderDetailsReducer,
  orderListMyReducer,
  orderPayReducer,
} from './Reducers/OrderReducres';
import { categoryListReducer } from './Reducers/CategoryReducers';
import {
  messageCreateReducer,
  messageMyListReducer,
  messageDeleteReducer,
  messageReplyReducer,
} from './Reducers/MessageReducers';
import { savedCardReducer } from './Reducers/savedCardReducer';
import { discountValidateReducer } from './Reducers/DiscountReducers';
import { guestReducer } from './Reducers/guestreducers';

const rootReducer = combineReducers({
  productList:         productListReducer,
  productDetails:      productDetailsReducer,
  productReviewCreate: productCreateReviewReducer,
  promoProducts:       promoProductsReducer,
  cart:                cartReducer,
  userLogin:           userLoginReducer,
  userRegister:        userRegisterReducer,
  userGoogleLogin:     userGoogleLoginReducer,
  userDetails:         userDetailsReducer,
  userUpdateProfile:   userUpdateProfileReducer,
  orderCreate:         orderCreateReducer,
  orderDetails:        orderDetailsReducer,
  orderPay:            orderPayReducer,
  orderListMy:         orderListMyReducer,
  categoryList:        categoryListReducer,
  messageCreate:       messageCreateReducer,
  messageMyList:       messageMyListReducer,
  messageDelete:       messageDeleteReducer,
  messageReply:        messageReplyReducer,
  savedCard:           savedCardReducer,
  discountValidate:    discountValidateReducer,
  guest:               guestReducer,
});

const cartItemsFromLocalStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const userInfoFromLocalStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const shippingAddressFromLocalStorage = localStorage.getItem("shippingAddress")
  ? JSON.parse(localStorage.getItem("shippingAddress"))
  : {};

const guestInfoFromLocalStorage = localStorage.getItem("guestInfo")
  ? JSON.parse(localStorage.getItem("guestInfo"))
  : {};

const initialState = {
  cart: {
    cartItems:       cartItemsFromLocalStorage,
    shippingAddress: shippingAddressFromLocalStorage,
  },
  userLogin: { userInfo: userInfoFromLocalStorage },
  guest:     guestInfoFromLocalStorage,
};

export default configureStore({
  reducer:        rootReducer,
  preloadedState: initialState,
  middleware:     [thunk],
});